import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  name: Yup.string().required().label("Sponsor name"),
});

const Inputs = [
  {
    name: "name",
    label: "Name",
    type: "text",
    value: "single",
    valueAttr: "name",
    required: true,
    customClass: "col-md-9",
  },
  {
    name: "isActive",
    label: "Is Active",
    type: "checkbox",
    value: "single",
    valueAttr: "isActive",
    defaultValue: () => true,
    customClass: "col-md-3",
  },
  {
    name: "url",
    label: "Website URL (default; opened from the sponsor badge)",
    type: "text",
    value: "single",
    valueAttr: "url",
    customClass: "col-md-6",
  },
  {
    name: "disclaimer",
    label: "Disclaimer (default, e.g. 'ΕΕΕΠ | 21+ | ΠΑΙΞΕ ΥΠΕΥΘΥΝΑ'; shown under the sponsor badge)",
    type: "text",
    value: "single",
    valueAttr: "disclaimer",
    customClass: "col-md-6",
  },
  {
    name: "countryDisclaimers",
    label: "Per country (overrides the defaults for viewers of that country; leave URL empty to keep the default)",
    type: "nestedArray",
    value: "multiple",
    valueAttr: "countryDisclaimers",
    collapsible: true,
    summaryFn: (row: any) => row.text || row.url || "Country override",
    columns: [
      {
        name: "countryId",
        label: "Country",
        type: "select",
        value: "single",
        valueAttr: "countryId",
        relationshipName: "countryIds",
        required: true,
      },
      {
        name: "text",
        label: "Disclaimer text",
        type: "text",
        value: "single",
        valueAttr: "text",
      },
      {
        name: "url",
        label: "Website URL",
        type: "text",
        value: "single",
        valueAttr: "url",
      },
    ],
  },
  {
    name: "color",
    label: "Primary Color (hex)",
    type: "text",
    value: "single",
    valueAttr: "color",
    customClass: "col-md-4",
  },
  {
    name: "secondaryColor",
    label: "Secondary Color (hex)",
    type: "text",
    value: "single",
    valueAttr: "secondaryColor",
    customClass: "col-md-4",
  },
  {
    name: "gradientSecondColor",
    label: "Gradient Second Color (hex)",
    type: "text",
    value: "single",
    valueAttr: "gradientSecondColor",
    customClass: "col-md-4",
  },
  {
    name: "logoFile",
    label: "Logo",
    type: "image",
    value: "single",
    valueAttr: "logo",
    customClass: "col-md-4",
    onChange: (localValues: any, event: any) => {
      localValues["logoFile"] = event.target.files[0];
      localValues["logo"] = URL.createObjectURL(event.target.files[0]);
    },
    clearImage: (localValues: any) => {
      const el = document.getElementById("logoFile") as HTMLInputElement | null;
      if (el) el.value = "";
      localValues["logoFile"] = "";
      localValues["logo"] = "";
    },
    transform: (path: string) => {
      if (!path) return path;
      if (path.includes("blob")) return path;
      if (path.startsWith("http")) return path;
      return process.env.VUE_APP_ASSETS_URL + "/" + path;
    },
  },
  {
    name: "backgroundImageFile",
    label: "Background Image (List)",
    type: "image",
    value: "single",
    valueAttr: "backgroundImage",
    customClass: "col-md-4",
    onChange: (localValues: any, event: any) => {
      localValues["backgroundImageFile"] = event.target.files[0];
      localValues["backgroundImage"] = URL.createObjectURL(event.target.files[0]);
    },
    clearImage: (localValues: any) => {
      const el = document.getElementById("backgroundImageFile") as HTMLInputElement | null;
      if (el) el.value = "";
      localValues["backgroundImageFile"] = "";
      localValues["backgroundImage"] = "";
    },
    transform: (path: string) => {
      if (!path) return path;
      if (path.includes("blob")) return path;
      if (path.startsWith("http")) return path;
      return process.env.VUE_APP_ASSETS_URL + "/" + path;
    },
  },
  {
    name: "backgroundImageForSinglePageFile",
    label: "Background Image (Single Page)",
    type: "image",
    value: "single",
    valueAttr: "backgroundImageForSinglePage",
    customClass: "col-md-4",
    onChange: (localValues: any, event: any) => {
      localValues["backgroundImageForSinglePageFile"] = event.target.files[0];
      localValues["backgroundImageForSinglePage"] = URL.createObjectURL(event.target.files[0]);
    },
    clearImage: (localValues: any) => {
      const el = document.getElementById("backgroundImageForSinglePageFile") as HTMLInputElement | null;
      if (el) el.value = "";
      localValues["backgroundImageForSinglePageFile"] = "";
      localValues["backgroundImageForSinglePage"] = "";
    },
    transform: (path: string) => {
      if (!path) return path;
      if (path.includes("blob")) return path;
      if (path.startsWith("http")) return path;
      return process.env.VUE_APP_ASSETS_URL + "/" + path;
    },
  },
  {
    name: "backgroundImageForGameCardFile",
    label: "Background Image (Game Card)",
    type: "image",
    value: "single",
    valueAttr: "backgroundImageForGameCard",
    customClass: "col-md-12",
    onChange: (localValues: any, event: any) => {
      localValues["backgroundImageForGameCardFile"] = event.target.files[0];
      localValues["backgroundImageForGameCard"] = URL.createObjectURL(event.target.files[0]);
    },
    clearImage: (localValues: any) => {
      const el = document.getElementById("backgroundImageForGameCardFile") as HTMLInputElement | null;
      if (el) el.value = "";
      localValues["backgroundImageForGameCardFile"] = "";
      localValues["backgroundImageForGameCard"] = "";
    },
    transform: (path: string) => {
      if (!path) return path;
      if (path.includes("blob")) return path;
      if (path.startsWith("http")) return path;
      return process.env.VUE_APP_ASSETS_URL + "/" + path;
    },
  },
  {
    name: "podium1File",
    label: "Podium 1 (1st place)",
    type: "image",
    value: "single",
    valueAttr: "podium1",
    customClass: "col-md-4",
    onChange: (localValues: any, event: any) => {
      localValues["podium1File"] = event.target.files[0];
      localValues["podium1"] = URL.createObjectURL(event.target.files[0]);
    },
    clearImage: (localValues: any) => {
      const el = document.getElementById("podium1File") as HTMLInputElement | null;
      if (el) el.value = "";
      localValues["podium1File"] = "";
      localValues["podium1"] = "";
    },
    transform: (path: string) => {
      if (!path) return path;
      if (path.includes("blob")) return path;
      if (path.startsWith("http")) return path;
      return process.env.VUE_APP_ASSETS_URL + "/" + path;
    },
  },
  {
    name: "podium2File",
    label: "Podium 2 (2nd place)",
    type: "image",
    value: "single",
    valueAttr: "podium2",
    customClass: "col-md-4",
    onChange: (localValues: any, event: any) => {
      localValues["podium2File"] = event.target.files[0];
      localValues["podium2"] = URL.createObjectURL(event.target.files[0]);
    },
    clearImage: (localValues: any) => {
      const el = document.getElementById("podium2File") as HTMLInputElement | null;
      if (el) el.value = "";
      localValues["podium2File"] = "";
      localValues["podium2"] = "";
    },
    transform: (path: string) => {
      if (!path) return path;
      if (path.includes("blob")) return path;
      if (path.startsWith("http")) return path;
      return process.env.VUE_APP_ASSETS_URL + "/" + path;
    },
  },
  {
    name: "podium3File",
    label: "Podium 3 (3rd place)",
    type: "image",
    value: "single",
    valueAttr: "podium3",
    customClass: "col-md-4",
    onChange: (localValues: any, event: any) => {
      localValues["podium3File"] = event.target.files[0];
      localValues["podium3"] = URL.createObjectURL(event.target.files[0]);
    },
    clearImage: (localValues: any) => {
      const el = document.getElementById("podium3File") as HTMLInputElement | null;
      if (el) el.value = "";
      localValues["podium3File"] = "";
      localValues["podium3"] = "";
    },
    transform: (path: string) => {
      if (!path) return path;
      if (path.includes("blob")) return path;
      if (path.startsWith("http")) return path;
      return process.env.VUE_APP_ASSETS_URL + "/" + path;
    },
  },
];

export { Inputs, validationSchema };
